// extracted by mini-css-extract-plugin
export default {"mainTitle":"_1rVKyftlNkOotGph83nHv-"};